/* eslint-disable implicit-arrow-linebreak */

export const apiContenedoresExportacionGet = ({ fechaInicio, fechaFin, filtroImportacion, filtroExportacion }) =>
    fetchApi("api/obtencion_mercancias", {
        method: "POST",
        body: JSON.stringify({
            fecha_inicio: fechaInicio,
            fecha_fin: fechaFin,
            fecha_filtro_importacion: filtroImportacion,
            fecha_filtro_exportacion: filtroExportacion,
        }),
        headers: {
            "Content-Type": "application/json",
        },
        default: [],
    });

export const apiCancelarDescargaPost = (idsPedimentosParaCancelar = []) =>
    fetchApi("api/cancelar_descargas", {
        method: "POST",
        body: JSON.stringify({
            pedimentos_id: idsPedimentosParaCancelar,
        }),
        headers: {
            "Content-Type": "application/json",
        },
    });
